import { render, staticRenderFns } from "./FlowProductList.vue?vue&type=template&id=2f9fc166&scoped=true&"
import script from "./FlowProductList.vue?vue&type=script&lang=js&"
export * from "./FlowProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9fc166",
  null
  
)

export default component.exports